import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";

const SVG_STYLE = {
  width: "100%",
  height: "100%",
  fill: "currentColor",
  shapeRendering: "geometricPrecision",
  transform: "translateZ(0)",
  backfaceVisibility: "hidden",
  WebkitFontSmoothing: "antialiased",
} as const;

interface ActionIconButtonProps {
  icon: React.ComponentType;
  onClick: () => void;
  label: string;
  telemetryName: string;
  iconSize: number;
}

export default function ActionIconButton({
  icon: Icon,
  onClick,
  label,
  telemetryName,
  iconSize,
}: ActionIconButtonProps) {
  return (
    <Tooltip title={label} enterDelay={500}>
      <IconButton
        onClick={onClick}
        aria-label={label}
        {...telemetryProps({ name: telemetryName, section: "unified_header", label })}
        sx={{ p: 1.5 }}
      >
        <Box
          sx={{
            width: iconSize,
            height: iconSize,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": SVG_STYLE,
          }}
        >
          <Icon />
        </Box>
      </IconButton>
    </Tooltip>
  );
}
